/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocietyLoginsData
 */
export interface SocietyLoginsData {
    /**
     * 
     * @type {string}
     * @memberof SocietyLoginsData
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof SocietyLoginsData
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof SocietyLoginsData
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SocietyLoginsData
     */
    registeredArtistName: string;
}

/**
 * Check if a given object implements the SocietyLoginsData interface.
 */
export function instanceOfSocietyLoginsData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "registeredArtistName" in value;

    return isInstance;
}

export function SocietyLoginsDataFromJSON(json: any): SocietyLoginsData {
    return SocietyLoginsDataFromJSONTyped(json, false);
}

export function SocietyLoginsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocietyLoginsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountId': json['account_id'],
        'username': json['username'],
        'password': json['password'],
        'registeredArtistName': json['registered_artist_name'],
    };
}

export function SocietyLoginsDataToJSON(value?: SocietyLoginsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_id': value.accountId,
        'username': value.username,
        'password': value.password,
        'registered_artist_name': value.registeredArtistName,
    };
}

